import { FiMessageSquare, FiUser, FiChevronRight } from 'react-icons/fi'
import './MessagePreview.css'

const MessagePreview = ({ messages }) => {
  if (!messages || messages.length === 0) {
    return (
      <div className="message-preview-empty">
        <div className="empty-icon">💬</div>
        <p>No messages yet</p>
        <span className="empty-hint">Start a conversation with an agent</span>
      </div>
    )
  }

  const getSenderInitial = (msg) => {
    if (msg.sender_name) return msg.sender_name.charAt(0).toUpperCase()
    return msg.sender_type === 'user' ? 'U' : 'A'
  }

  const getSenderColor = (msg) => {
    return msg.sender_type === 'user'
      ? 'var(--accent-primary)'
      : 'var(--accent-secondary)'
  }

  const formatTime = (dateStr) => {
    const date = new Date(dateStr)
    const now = new Date()
    const diffMs = now - date
    const diffMins = Math.floor(diffMs / 60000)
    const diffHours = Math.floor(diffMs / 3600000)

    if (diffMins < 1) return 'Just now'
    if (diffMins < 60) return `${diffMins}m ago`
    if (diffHours < 24) return `${diffHours}h ago`
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' })
  }

  const truncateContent = (content, maxLen = 80) => {
    if (!content) return ''
    return content.length > maxLen ? content.substring(0, maxLen) + '...' : content
  }

  return (
    <div className="message-preview-list">
      {messages.map((msg, idx) => (
        <div key={msg.id || idx} className="message-preview-item">
          <div
            className="message-preview-avatar"
            style={{ background: getSenderColor(msg) }}
          >
            {getSenderInitial(msg)}
          </div>
          <div className="message-preview-content">
            <div className="message-preview-header">
              <span className="message-preview-sender">
                {msg.sender_name || (msg.sender_type === 'user' ? 'You' : 'Agent')}
              </span>
              <span className="message-preview-time">
                {formatTime(msg.created_at)}
              </span>
            </div>
            <div className="message-preview-text">
              {truncateContent(msg.content)}
            </div>
          </div>
          {!msg.is_read && msg.sender_type !== 'user' && (
            <div className="message-preview-unread" />
          )}
        </div>
      ))}
    </div>
  )
}

export default MessagePreview
